import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-500 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h3 className="font-heading text-xl mb-4 text-background-50">香香漫画</h3>
            <p className="text-sm text-background-50/80 leading-relaxed">
              香香漫画致力于为广大漫画爱好者提供免费、优质的在线阅读服务。
              海量漫画资源，下拉式阅读体验，让追更更轻松。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-lg mb-4 text-background-50">快速导航</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg mb-4 text-background-50">热门分类</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/category?tab=hot-blooded" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  热血漫画
                </Link>
              </li>
              <li>
                <Link to="/category?tab=romance" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category?tab=fantasy" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category?tab=comedy" className="text-sm text-background-50/80 hover:text-background-50 transition-colors no-underline">
                  搞笑漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-lg mb-4 text-background-50">联系我们</h3>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center"></i>
                contact@xiangxiangmanga.com
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-wechat-line w-4 h-4 flex items-center justify-center"></i>
                微信公众号：香香漫画
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/80">
                <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
                中国广东省广州市
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-50/20 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-sm text-background-50/60">
            &copy; {currentYear} 香香漫画 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}